import React from "react";
import {connect} from 'react-redux';

import {USER_ROLES} from "../../consts/user";
import {selectUserRoles} from "../../store/user/selectors";
import StudentMainPage from "../pages/studentMainPage";
import {checkSuperviser} from "../../utils";
import BackOfficeMainPageComponent from "../pages/backOffice";

const View = ({roles}: {roles: USER_ROLES[]}) => {
    if (checkSuperviser(roles)) {
      return <BackOfficeMainPageComponent />;
    }
    
    //@TODO: add conditions for renderingComponents according to view
    return <StudentMainPage />;
}

//@ts-ignore
const mapStateToProps = (state) => { 
    return {
        roles: selectUserRoles(state),
    }
}

export default connect(mapStateToProps, null)(View);